export default "/images/014c06a7bda4c826a9bb48d5c1bc332d.avif";